/** Store admin role after Milestone 1 (`admin` kept for old sessions). */
export const isStoreAdmin = (type?: string | null) =>
	type === 'store_admin' || type === 'admin'

export const isSuperAdmin = (type?: string | null) => type === 'super_admin'
